import React from "react";
import { PrimaryButton } from "./UI";
import { APP_CONFIG } from "../utils/constants";

export default function AppHeader({ appName, onLogout, isDarkMode, setIsDarkMode, showLogout }) {
  const displayName = appName === "NMLS Exam Questions" ? APP_CONFIG.name : appName;

  return (
    <header className={`sticky top-0 z-20 border-b ${isDarkMode ? 'border-slate-700 bg-slate-900/80' : 'border-slate-200 bg-white/80'} backdrop-blur transition-colors`}>
      <div className="px-5 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/logo-icon.svg" alt="PassMLOExam logo" className="h-10 w-10" />
          <div className="leading-tight">
            <div className={`font-semibold ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>{displayName}</div>
            <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Practice • Flashcards • Analytics</div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button 
            onClick={() => setIsDarkMode(!isDarkMode)}
            className={`px-3 py-2 rounded-lg text-xl transition ${isDarkMode ? 'bg-slate-800 text-yellow-400 hover:bg-slate-700' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}
            title="Toggle dark/light mode"
          >
            {isDarkMode ? '🌙' : '☀️'}
          </button>
          {showLogout && <PrimaryButton onClick={onLogout}>Logout</PrimaryButton>}
        </div>
      </div>
    </header>
  );
}
